import { Directive, Input } from '@angular/core';

/**
 * No-op replacement for the unmaintained `angular2-text-mask` directive.
 * Keeps templates compiling without applying any masking; existing inputs continue
 * to behave as plain text fields.
 */
@Directive({
    standalone: false,
    selector: '[textMask]'
})
export class TextMaskStubDirective {
    @Input('textMask') textMask: any;
}
